/**
 * تخزين آمن: يتعامل مع Safari الخاص وقيود ITP حيث يرمي SecurityError عند الوصول للتخزين.
 */

const PROBE_KEY = '__storage_access_probe__'

function probeNativeStorage(storage: Storage | null | undefined): boolean {
  if (typeof window === 'undefined' || storage == null) return false
  try {
    storage.setItem(PROBE_KEY, PROBE_KEY)
    storage.removeItem(PROBE_KEY)
    return true
  } catch {
    return false
  }
}

function createMemoryStorage(): Storage {
  const map = new Map<string, string>()
  return {
    get length() {
      return map.size
    },
    clear() {
      map.clear()
    },
    getItem(key: string) {
      const v = map.get(String(key))
      return v === undefined ? null : v
    },
    key(index: number) {
      if (index < 0 || index >= map.size) return null
      const keys = [...map.keys()]
      return keys[index] ?? null
    },
    removeItem(key: string) {
      map.delete(String(key))
    },
    setItem(key: string, value: string) {
      map.set(String(key), String(value))
    },
  }
}

function createSafeStorage(getNative: () => Storage | null | undefined): Storage {
  if (typeof window === 'undefined') {
    return createMemoryStorage()
  }
  const native = getNative()
  if (probeNativeStorage(native)) {
    return native as Storage
  }
  return createMemoryStorage()
}

/** يعيد true إذا كان localStorage الأصلي قابلاً للاستخدام (للمقاييس فقط). */
export function isNativeLocalStorageAvailable(): boolean {
  if (typeof window === 'undefined') return false
  return probeNativeStorage(window.localStorage)
}

/** يعيد true إذا كان sessionStorage الأصلي قابلاً للاستخدام (للمقاييس فقط). */
export function isNativeSessionStorageAvailable(): boolean {
  if (typeof window === 'undefined') return false
  return probeNativeStorage(window.sessionStorage)
}

export const safeLocal = createSafeStorage(() =>
  typeof window !== 'undefined' ? window.localStorage : null
)

export const safeSession = createSafeStorage(() =>
  typeof window !== 'undefined' ? window.sessionStorage : null
)
